import { ref, computed, reactive, unref, watch } from 'vue'
import { defineStore } from 'pinia'
import {
  type Period,
  type Payslip,
  ACCOUNT_TYPE,
  ACCOUNT_SIDE,
  type Account,
  type Employee,
  PAY_CYCLE,
  PERIOD_STATUS
} from './types'
import { faker } from '@faker-js/faker'
import dayjs from 'dayjs'
import { usePayslipStore } from './payslip'
import { useAppStore } from './app'
import { useTableStore } from '@/stores/table'
import axios from 'axios'


const apiURL: string = import.meta.env.VITE_API_URL + '/api'
// const apiURL = "http://localhost:4000/api"

const api = axios.create({
  baseURL: apiURL + '/v1'
})


export const usePeriodStore = defineStore('period', () => {
  // Period Detail
  const periods = reactive<Period[]>([])
  const selectedPeriod = ref({} as Period) // selected in table
  const thisPeriod = ref({} as Period) //for form editing

  const showForm = ref(false)


  const payslipStore = usePayslipStore()
  const appStore = useAppStore()
  const tableStore = useTableStore()

  function generatePeriods() {
    // For Weekly
    let daysOff = [6] // Sundays
    let currentDate = dayjs()
    const firstDayOfMonth = currentDate.startOf('year')
    const dayOfWeek = firstDayOfMonth.day() 

    // Start Week on Fridays, dayOfWeek + daysToAdd = 5 
    const daysToAdd = dayOfWeek < 5 ? 6 - dayOfWeek : 13 - dayOfWeek

    let startDate = firstDayOfMonth.add(daysToAdd, 'day').toDate()
    
    let cylcle_number = 1

    let workDays = 0
    let cDate = dayjs().toDate()
    while (dayjs(startDate).year() == dayjs().year()) {
      const payload = {} as Period
      // payload.uuid = faker.string.uuid()
      payload.pay_cycle = PAY_CYCLE.Weekly
      payload.start_date = startDate
      payload.end_date = dayjs(payload.start_date).add(6, 'day').toDate()
      payload.status = PERIOD_STATUS.Closed

      workDays = 0
      cDate = payload.start_date
      while (payload.start_date <= cDate && cDate <= payload.end_date) {
        if (!daysOff.includes(dayjs(cDate).day())) {
          workDays += 1
        }
        cDate = dayjs(cDate).add(1, 'day').toDate()
      }

      // holidays
      const holidays = tableStore.HOLIDAY.filter((holiday: any) => {
        if (!holiday.Day) { return false}

        const date = dayjs()
          .set('day', holiday.Day.split('/')[1])
          .set('month', holiday.Day.split('/')[0])
        return dayjs(payload.start_date).isBefore(date) && dayjs(payload.end_date).isAfter(date)
          ? true
          : false
      }).length

      payload.workdays = workDays - holidays
      payload.holidays = holidays

      // payload.pop('uuid')

      savePeriod(payload)
      cylcle_number += 1
      startDate = dayjs(startDate).add(7, 'day').toDate()
    }

    // For Semi-Monthly
    daysOff = [0] // Sundays
    currentDate = dayjs()
    const firstDayOfYear = currentDate.startOf('year')
    startDate = firstDayOfYear.toDate()

    cylcle_number = 1
    while (dayjs(startDate).year() == dayjs().year()) {
      const payload = {} as Period
      // payload.uuid = faker.string.uuid()
      payload.pay_cycle = PAY_CYCLE.SemiMonthly
      payload.start_date = startDate
      if (dayjs(payload.start_date).date() <= 15) {
        payload.end_date = dayjs(payload.start_date).add(14, 'day').toDate()
        startDate = dayjs(payload.end_date).add(1, 'day').toDate()
      } else {
        payload.end_date = dayjs(payload.start_date).endOf('month').toDate()
        startDate = dayjs(payload.end_date).endOf('month').add(1, 'day').toDate()
      }
      payload.status = PERIOD_STATUS.Closed

      workDays = 0
      cDate = payload.start_date
      while (payload.start_date <= cDate && cDate <= payload.end_date) {
        if (!daysOff.includes(dayjs(cDate).day())) {
          workDays += 1
        }
        cDate = dayjs(cDate).add(1, 'day').toDate()
      }

      // holidays
      const holidays = tableStore.HOLIDAY.filter((holiday: any) => {
        if (!holiday.Day) { return false}

        const date = dayjs()
          .set('day', holiday.Day.split('/')[1])
          .set('month', holiday.Day.split('/')[0])
        return dayjs(payload.start_date).isBefore(date) && dayjs(payload.end_date).isAfter(date)
          ? true
          : false
      }).length

      payload.workdays = workDays - holidays
      payload.holidays = holidays

      savePeriod(payload)
      cylcle_number += 1
    }
  }

  async function getPeriods() {

    const response = (await api.get('/periods.json'))
    if (response.status == 200) {
      // employees.push(response.data.data)
      periods.length=0
      response.data.data.forEach((item: Period)=>{
        periods.push(item)
      })
    } else {
    }


  }

  async function periodsThisYear(year: string) {
    const y = year

    const start_date = dayjs(`${y}-01-01`).startOf('year').format('YYYY-MM-DDTHH:mm:ss')
    const end_date = dayjs(`${y}-01-01`).endOf('year').format('YYYY-MM-DDTHH:mm:ss')
    const response = (await api.get('/periods?start_date=' + start_date + '&end_date=' + end_date))
    if (response.status == 200) {
      periods.length=0 
      response.data.data.forEach((item: Period)=>{
        periods.push(item)
      })
    } else {
    }


  }

  async function savePeriod(payload: Period) {
    if (payload.uuid) {
      const response = (await api.put('/periods/' + payload.uuid, payload))

      if (response.status == 200) {
        const idx = periods.findIndex((item: Period) => item.uuid == payload.uuid)
        periods.splice(idx, 1, response.data)
      } else {
      }
    } else {
      const response = (await api.post('/periods.json', payload))

      if (response.status == 200) {
        periods.push(response.data)
      } else {
      }
    }
  }

  async function deletePeriod(payload: Period) {
    const response = await api.delete("/periods/" + payload.uuid);
    // record was actually deleted
    if (response.status == 200) {
      const ndx = periods.findIndex(
        (item: Period) => item.uuid != payload.uuid
      );
      periods.splice(ndx,1)
    }
  }

  function addPeriod(payload: Period) {

    periods.push(payload)
  }

  const togglePeriodStatus = async (payload: Period) => {
    const idx = periods.findIndex((item: Period) => item.uuid == payload.uuid)
    payload.status =
      payload.status == PERIOD_STATUS.Open ? PERIOD_STATUS.Closed : PERIOD_STATUS.Open

    // if (payload.status == PERIOD_STATUS.Open) {
    //    //   appStore.isLoading = true

    // }
    
    const response = await api.put('/periods/' + payload.uuid, payload)

    if (response.status == 200) {
      // periods.push(response.data)
      periods.splice(idx, 1, payload)
      // payslipStore.generatePayslips(payload)

    } else {
    }


  }

  const  periodName = computed(()=>(uuid: string)=> {
    const  p = periods.find((item: Period) => item.uuid == uuid) as Period
    return dayjs(p['start_date']).format('MM/DD/YYYY') + " - " + dayjs(p['end_date']).format('MM/DD/YYYY') + " (" + p['pay_cycle'] + ")"
  })

  const years = computed(()=>{
    // const y = periods.map(item=>dayjs(item.start_date).year())
    const y = appStore.thisYear*1

    return [y-5,y-4,y-3,y-2,y-1,y]
  })



  // The contribution reports cover a calendar month, so they are offered on the
  // month's last period only: no later period of the same pay cycle ends in the
  // same month as this one.
  const isFinalPeriodOfMonth = (period?: Period) => {
    if (!period?.uuid || !period.end_date) return false
    const end = dayjs(period.end_date)
    return !periods.some(
      (other: Period) =>
        other.uuid != period.uuid &&
        other.pay_cycle == period.pay_cycle &&
        dayjs(other.end_date).isSame(end, 'month') &&
        dayjs(other.end_date).isAfter(end)
    )
  }

  return {
    showForm,
    periods,
    isFinalPeriodOfMonth,
    selectedPeriod,
    thisPeriod,
    years,

    generatePeriods,
    periodsThisYear,
    getPeriods,
    savePeriod,
    deletePeriod,
    togglePeriodStatus,

    periodName
  }
})
